<div class="h-full min-h-0 overflow-y-auto">
  <div class="flex gap-2 items-center mb-4">
    <app-input-buscador
      placeholder="Buscar empleado por nombre o email"
      [(valor)]="busquedaEmpleado"
      class="flex-1"
      (input)="onBuscarEmpleado()"
    />
    <app-button
      label="Nuevo Empleado"
      icon="bi bi-plus"
      variant="primary"
      (onClick)="modal_crear_empleado.set(true)"
    />
  </div>
  <div class="overflow-auto">
    <div class="grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-4">
      @for (empleado of filtroEmpleados(); track $index) {
        <app-card-empleado [empleado]="empleado" />
      } @empty {
        <div class="col-span-full text-center text-slate-500 py-10">
          No se encontraron empleados.
        </div>
      }
    </div>
  </div>
</div>

<app-dialog
  header="Crear empleado"
  [modal]="true"
  [(visible)]="modal_crear_empleado"
  (onHide)="modal_crear_empleado.set(false)"
  size="md"
>
  @if (modal_crear_empleado()) {
    <app-crear-empleado (cerrar)="closeCrearEmpleado($event)"></app-crear-empleado>
  }
</app-dialog>
